<script lang="ts" setup>
import { computed } from 'vue'
import { translate } from '@/i18n/i18n.ts'
import { formatPrice } from '@/utils/price.util.ts'

import { LTable, LTBody, LTD, LTH, LTHead, LTR } from '@wgg.hyve/hyve-ui-library'

const props = defineProps({
  modalData: {
    type: Object,
    default: () => ({})
  }
})

const priceData = computed(() => {
  const rawPriceGroups = props.modalData.price_groups ?? props.modalData.priceGroups ?? {}
  const priceGroups = Array.isArray(rawPriceGroups) ? rawPriceGroups : Object.values(rawPriceGroups)

  return priceGroups
    .filter(
      (group) =>
        (group.device_price_from !== undefined && group.device_price_to !== undefined) ||
        (group.intervals?.length ?? 0) > 0
    )
    .map((group) => ({
      device_price_range: translate(
        'modal_content.price_info.value',
        formatPrice(group.device_price_from || 0, true),
        formatPrice(group.device_price_to || 0, true)
      ),
      monthly: translate(
        'modal_content.price_info.price',
        formatPrice(group.intervals?.[0]?.value || 0)
      ),
      annually: translate(
        'modal_content.price_info.price_subline',
        formatPrice(group.intervals?.[1]?.value || 0)
      )
    }))
})
</script>

<template>
  <div class="price-info-modal">
    <div class="price-info-modal__introduction">
      <span
        class="price-info-modal__topline"
        v-html="translate('modal_content.price_info.topline')"
      />
      <p v-html="translate('modal_content.price_info.paragraph_1')" />
    </div>

    <LTable align="center">
      <LTHead>
        <LTR>
          <LTH>{{ $t('modal_content.price_info.value_headline') }}</LTH>
          <LTH>{{ modalData.name }}</LTH>
        </LTR>
      </LTHead>

      <LTBody>
        <LTR v-for="(priceObject, index) in priceData" :key="index" size="xs">
          <LTD variant="subtle" text-style="highlight">
            {{ priceObject.device_price_range }}
          </LTD>

          <LTD>
            {{ priceObject.monthly }}
            <div class="price-info-modal__subline">{{ priceObject.annually }}</div>
          </LTD>
        </LTR>
      </LTBody>
    </LTable>
  </div>
</template>

<style lang="scss" scoped>
@import 'price-info-modal';
</style>
